// ==========================================================================
// PERSISTANCE DE SESSION DES FORMULAIRES DE MÉTHODE
// Store fourni par AppMain (mémoire React uniquement — aucune donnée client
// sur disque). Chaque formulaire est cloisonné par un id de scope ("dcf",
// "us", "fr:vp"…) : aucune fuite inter-méthodes par construction.
// useSessionForm remplace useState pour l'état de formulaire : réhydrate
// depuis le store au montage, sauvegarde au démontage (= à la navigation).
// Extrait d'App.jsx pour être partagé avec les services en fichier séparé
// (PariteFusion…) sans import circulaire.
// ==========================================================================
import React, { useState, useEffect, useRef } from "react";

export const FormStoreCtx = React.createContext(null); // {get:(id)=>saved, save:(id,f)=>void, saveKey:(id,key,v)=>void}
export const FormIdCtx    = React.createContext(null); // id de scope du formulaire monté
export const FormScope    = ({id, children}) => <FormIdCtx.Provider value={id}>{children}</FormIdCtx.Provider>;
export const useSessionForm = (initial) => {
  const store = React.useContext(FormStoreCtx);
  const id    = React.useContext(FormIdCtx);
  const [f, sF] = useState(() => {
    const saved = store && id ? store.get(id) : null;
    return saved ? {...initial, ...saved} : initial;
  });
  const ref = useRef(null); ref.current = {f, store, id};
  useEffect(() => () => { const {f, store, id} = ref.current; if (store && id) store.save(id, f); }, []);
  return [f, sF];
};
// Variante clé/valeur : persiste UNE valeur sous une sous-clé du scope courant.
// Pour les services à état multiple (Revue, Credit Rating, Parité) — chaque
// morceau d'état garde son setter, la sauvegarde au démontage est par sous-clé.
export const useSessionState = (key, initial) => {
  const store = React.useContext(FormStoreCtx);
  const id    = React.useContext(FormIdCtx);
  const [v, setV] = useState(() => {
    const saved = store && id ? store.get(id) : null;
    if (saved && key in saved) return saved[key];
    return typeof initial === "function" ? initial() : initial;
  });
  const ref = useRef(null); ref.current = {v, store, id};
  useEffect(() => () => { const {v, store, id} = ref.current; if (store && id) store.saveKey(id, key, v); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return [v, setV];
};
